import { apiSlice } from "../slices/apiSlice";
import { setCredentials } from "../slices/authSlice";
import { removeUsers } from "../slices/userSlice";
import { removeAttendances } from "../slices/attendanceListSlice";
import { removeSelfUsers } from "../slices/userSelfSlice";
import { clearGymData } from "../slices/gymDataSlice";

// Makes nextInfo the active gym everywhere: userInfo swap, per-gym data
// slices, RTK Query cache. The previous gym's cached lists must never leak
// into the next gym's screens.
export const applyGymSwitch = (dispatch, nextInfo) => {
  dispatch(setCredentials(nextInfo));
  dispatch(removeUsers());
  dispatch(removeAttendances());
  dispatch(removeSelfUsers());
  dispatch(clearGymData());
  dispatch(apiSlice.util.resetApiState());
};
